export const DELIVERY_ESTIMATE_QUERY = `
    query ($zipCode: String!, $state: String!) {
        getDelieveryEstimate(zipCode: $zipCode, state: $state) {
            start_window
            end_window
        }
    }
`
